<template>
<body id="page-top" class="body-bg">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio certificate-login-section" id="portfolio">
            <div class="container">
              <form @submit.prevent="handleSubmit">
                <div>
               <iframe class="form-iframe" src="https://docs.google.com/forms/d/e/1FAIpQLScfbZonpd3qbGjOyjn8611eT9ArGV9kJmDffGMpc4_BfmQQYQ/viewform?fbclid=IwAR34Yf5E1nHdhc9CpFmayAdHNDPHUraw5YRiZ3VfDNZmFOnfI4I2fadPgTg" crossorigin="anonymous"></iframe>
        </div>

               <div class="col-md-12 iframe-back-btn">
                  <router-link to="/member-page"><a style="float:left" type="button" class="btn btn-primary btn-lg">BACK</a></router-link>
            </div>
            </form>
             </div> 

             

        </section>
        
</body>
</template>

<script>
export default {
  name: 'PhilLogin',
  data() {
    return {

    }
  },
  created() {
    if (localStorage.getItem('CertNo') === null) {
          this.$router.push('/login');
      }
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
